import loadGa from '../scripts/loadGa';
import loadGotie from '../scripts/loadGotie';
import initComscore from '../scripts/initComscore';
import initFbTrack from '../scripts/initFbTrack';
import initGoogleConversion from '../scripts/initGoogleConversion';
import { fbTrackPageView } from '../../common/utils/fbTrack';
import loadAmpBingTracking from '../scripts/loadAmpBingTracking';
import loadYahooPixelTracking from '../scripts/loadYahooPixelTracking';
import { comscoreTrackPageview } from './comscoreUtils';
import { gotieTrack } from './gotieTracking';
import ga from './gaTracking';

let previousPath = null;
let stepNumber = 0;

export function initClientAnalytics(isUserOptedOut, desktopOS, location) {
  loadGa(desktopOS);
  loadGotie();
  gotieTrack(location);
  initFbTrack();
  initGoogleConversion();
  loadAmpBingTracking();
  loadYahooPixelTracking();
  initComscore(isUserOptedOut);
}

// we're using getState() so that we always have access to the latest store values
export default function createAnalytics(tuneInApiClient, getState, history) {
  stepNumber = 0;
  function sendPageView(path) {
    tuneInApiClient.reports.sendPageView({
      s: stepNumber,
      r: path,
    });

    previousPath = path;
    stepNumber += 1;
  }

  if (history) {
    const referrer = document.referrer;
    if (referrer) {
      sendPageView(referrer);
    }
    sendPageView(history.location.pathname);
  }

  return {
    sendPageView: (location) => {
      const path = location.pathname || '';
      ga('set', 'page', path);
      ga('send', 'pageview');
      gotieTrack(location);
      // we're using getState() so that we always have access to the latest store values
      comscoreTrackPageview(getState());
      fbTrackPageView(path);

      if (window.gtagPageChange) {
        window.gtagPageChange(path);
      }

      if (path !== previousPath) {
        sendPageView(path);
      }
    },
  };
}
